import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { CampaignPlaceholderId } from '../../shared/enums/campaignPlaceholderId';
import { type CampaignCreative } from '../../shared/types/campaignCreative';
import { CampaignType } from '../enums/CampaignType';
import { type HeaderContext } from '../types';

type WithPlaceholder = { placeholderId?: CampaignPlaceholderId; name?: CampaignPlaceholderId };

type UseCampaignsResult<T> =
    | { hasCampaigns: false; headerBanner?: undefined }
    | { hasCampaigns: true; headerBanner: T | undefined };

function getByPlaceholder<T extends WithPlaceholder>(
    items: T[] | undefined,
    placeholderId: CampaignPlaceholderId,
): T | undefined {
    return items?.find(item => item.placeholderId === placeholderId || item.name === placeholderId);
}

export function useCampaigns<T extends WithPlaceholder = CampaignCreative>(
    type: CampaignType = CampaignType.Creative,
): UseCampaignsResult<T> {
    const { campaigns } = useFragmentContext<HeaderContext>();

    const list =
        type === CampaignType.Creative
            ? (campaigns?.creatives as T[] | undefined)
            : (campaigns?.dynamicYield as T[] | undefined);

    if (!list?.length) return { hasCampaigns: false };

    return {
        hasCampaigns: true,
        headerBanner: getByPlaceholder(list, CampaignPlaceholderId.HeaderBanner),
    };
}
